module.exports = __webpack_public_path__ + "img/logo-emn-bw.15198b4a.png";